class Auth {
  static getToken() {
    return localStorage.getItem("user");
  }

  static getUserDetails(key = null) {
    const userString = this.getToken();

    if (!userString) return "";

    let user = null;
    try {
      user = JSON.parse(userString);
    } catch (error) {
      console.error("Error parsing user JSON:", error);
      return "";
    }

    return key ? user[key] : user;
  }

  static logout() {
    localStorage.removeItem("user");
    window.location.href = "/";
  }
}

export default Auth;
